import styled from "styled-components";
import { COLORS } from "../../../layout/theme";
import { Button } from "antd";

export const AntdButton = styled(Button)`
	background-color: ${(props) =>
		props.$active ? COLORS.Primary : COLORS.White};
	color: ${(props) => (props.$active ? COLORS.White : COLORS.Primary)};
	border-color: ${COLORS.Primary};
	border-radius: 5px;
	${(props) =>
		props.height &&
		`
      height: ${props.height}px;
    `}
	${(props) =>
		props.width &&
		`
      width: ${props.width}px;
    `}
  ${(props) => props.fontSize && `font-size: ${props.fontSize}px`}
`;

export const Inner = styled.div`
	min-height: 80vh;
	padding: 0 84px 32px;

	@media only screen and (max-width: 768px) {
		padding: 0 72px 24px;
	}
`;

export const PageHeader = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	gap: 20px;
	margin-bottom: 24px;

	@media only screen and (max-width: 900px) {
		flex-direction: column;
		align-items: stretch;
	}
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 6px;
`;

export const Container = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 20px;
`;

export const PageTitle = styled.h1`
	margin: 0;
	font-size: 28px;
	font-weight: 700;
	line-height: 1.1;
	color: #111827;
	letter-spacing: -0.03em;
`;

export const PageSub = styled.p`
	margin: 0;
	font-size: 14px;
	color: #6b7280;
`;

export const ButtonContainer = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
`;

export const Shell = styled.div`
	background: ${COLORS.White};
	border: 1px solid #e4e6ea;
	border-radius: 16px;
	display: grid;
	grid-template-columns: 230px 1fr;
	min-height: 520px;
	overflow: hidden;
	box-shadow:
		0 1px 3px rgba(0, 0, 0, 0.06),
		0 1px 2px rgba(0, 0, 0, 0.04);

	@media only screen and (max-width: 1000px) {
		grid-template-columns: 1fr;
	}
`;

export const Sidebar = styled.aside`
	border-right: 1px solid #e4e6ea;
	padding: 12px 8px;
	display: flex;
	flex-direction: column;
	gap: 2px;
	background: ${COLORS.White};

	@media only screen and (max-width: 1000px) {
		border-right: none;
		border-bottom: 1px solid #e4e6ea;
	}
`;

export const SidebarSectionLabel = styled.div`
	font-size: 10px;
	font-weight: 700;
	color: #9ca3af;
	text-transform: uppercase;
	letter-spacing: 0.08em;
	padding: 8px 12px 4px;
`;

export const SidebarItem = styled.button`
	width: 100%;
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px 12px;
	border-radius: 10px;
	font-size: 13px;
	font-weight: ${(props) => (props.$active ? 600 : 500)};
	color: ${(props) => (props.$active ? "#185fa5" : "#6b7280")};
	background: ${(props) => (props.$active ? "#e6f1fb" : "transparent")};
	border: none;
	cursor: pointer;
	transition: all 0.15s;

	&:hover {
		background: ${(props) => (props.$active ? "#e6f1fb" : "#f8f9fa")};
		color: #111827;
	}
`;

export const SidebarIcon = styled.div`
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	opacity: ${(props) => (props.$active ? 1 : 0.7)};
`;

export const SidebarLabel = styled.span`
	flex: 1;
	text-align: left;
`;

export const DetailPanel = styled.section`
	padding: 32px 32px 36px;
	display: flex;
	flex-direction: column;

	@media only screen and (max-width: 768px) {
		padding: 20px 16px 24px;
	}
`;

export const ChildrenContainer = styled.div`
	width: 100%;
`;
